export function normalizeSearchText(value: string) {
  return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLocaleLowerCase("it-IT");
}

export function matchesSearchText(
  query: string,
  values: Array<string | number | null | undefined>,
) {
  const needle = normalizeSearchText(query);
  if (!needle) return true;

  return values.some((value) => normalizeSearchText(String(value ?? "")).includes(needle));
}
